
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

import { UserService } from '../../services/user.service';
import { NgForm } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { ToastrService } from 'ngx-toastr';
import { User } from '../../models/user';
import { AuthService } from '../../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { MatSort } from '@angular/material/sort';
import { NgxSpinnerService } from 'ngx-spinner';
import { Role } from '../../models/role';
import { CountriesDataService } from '../../services/countriesData.service';
import { Country } from '../../models/country';
import { switchMap } from 'rxjs/operators';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
    selector: 'app-registration',
    templateUrl: './registration.component.html'
})


export class RegistrationComponent implements OnInit {

    constructor(private translate: TranslateService, public service: UserService, private countryService: CountriesDataService, private toastr: ToastrService, private authService: AuthService, private spinner: NgxSpinnerService) { }

    user = new User();
    countrySelect;
    roles;
    country ;
    dataSource = new MatTableDataSource();
    displayedColumns: string[] = ['userID', 'name', 'employeeID', 'role','country', 'blocked', 'disabled', 'actions'];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    readonlyTextbox = false;
    isLoading = true;
    newOrEdit: boolean = false;
    @ViewChild('roleID', { read: NgSelectComponent }) ngSelectRole: NgSelectComponent;
    @ViewChild('countryId', { read: NgSelectComponent }) ngSelectCountry: NgSelectComponent;

    ngOnInit() {
        this.fillUserGrid();
    }

    fillUserGrid() {
        this.isLoading = true;
        this.roles = this.service.getRoleList();
        this.country = this.countryService.getCountriesList();
        this.service.getUserList().subscribe(
            res => {               
                this.isLoading = false;
                this.dataSource = new MatTableDataSource();
                this.dataSource.data = res as [];
                this.dataSource.sort = this.sort;
                this.dataSource.paginator = this.paginator;
                this.dataSource.paginator._intl.itemsPerPageLabel = this.translate.instant("REG.ITEMS_PER_PAGE");
            });
    }


    onSubmit(regForm: NgForm) {
        this.spinner.show();
        this.user.logUser = this.authService.getLoginFromToken();         
        this.user.country.id = this.user.role.roleID == 2 ? this.user.country.id : undefined;       
        this.service.saveUser(this.user).subscribe(
            res => {
                
                this.resetForm(regForm);
                //this.ngSelectCountry.handleClearClick();
                //this.ngSelectRole.handleClearClick();                
                this.fillUserGrid();
                this.toastr.success(this.translate.instant("COM.true"), '');
                this.spinner.hide();
            },
            err => {           
                this.spinner.hide();

            }
        )

    }

    newRow() {
        this.newOrEdit = true;
        this.user.editMode = false;
    }

    resetForm(regForm: NgForm) {
        this.newOrEdit = false;
        this.readonlyTextbox = false;
        regForm.resetForm();
        this.fillUserGrid();
    }

    editRow(item: User) {
        window.scrollTo(0, document.body.scrollHeight);
        this.newOrEdit = true;
        //this.user = item;
        let selectedItem = JSON.parse(JSON.stringify(item));
        this.user = selectedItem;
        this.user.logUser = this.authService.getLoginFromToken();
        this.user.editMode = true;
        this.readonlyTextbox = true;
    }


    unlockRow(item: User) {
        this.spinner.show();
        item.logUser = this.authService.getLoginFromToken();
        this.isLoading = true;
        this.service.unlockUser(item).subscribe(
            res => {
                this.fillUserGrid();
                this.toastr.success(this.translate.instant("COM.true"), '');
                this.spinner.hide();
            },
            err => {                 
                this.spinner.hide();
            }
        );
        this.isLoading = false;
        
    }

    delteRow(item: User) {
        this.spinner.show();
        this.isLoading = true;
        item.logUser = this.authService.getLoginFromToken();

        this.service.deleteUser(item).subscribe(
            res => {
                this.fillUserGrid();
                this.toastr.success(this.translate.instant("COM.true"), '')
                this.spinner.hide();
            },
            err => {                                
                this.spinner.hide();
            }
        );
        this.isLoading = false;
    }

    activateRow(item: User) {
        this.spinner.show();
        item.logUser = this.authService.getLoginFromToken();
        this.isLoading = true;
        this.service.activateUser(item).subscribe(
            res => {
                this.fillUserGrid();
                this.toastr.success(this.translate.instant("COM.true"), '')
                this.spinner.hide();
            },
            err => {
                
                this.spinner.hide();
            }
        );
        this.isLoading = false;
        
    }

}
